import React, { ReactElement, useRef } from "react";
import type { ElementRef } from "react";
import { TextInput, View } from "react-native";
import { FormikHandlers } from "formik";
import MobileNumberInput from "../../../components/Inputs/MobileNumberInput";
import PasswordText from "../../../components/Inputs/PasswordText";
import { useTranslateText } from "../../../utils/translations";
import { loginStyles as styles } from "./styles";

type InputsProps = {
  values: {
    telephone: string;
    password: string;
  };
  handleChange: FormikHandlers["handleChange"];
  submitForm: () => void;
  setFieldTouched: (arg0: string) => void;
  touched: {
    telephone: boolean;
    password: boolean;
  };
  errors: {
    telephone: string;
    password: string;
  };
};

type TextInputRef = ElementRef<typeof TextInput>;

const Inputs = ({
  submitForm,
  values,
  handleChange,
  setFieldTouched,
  touched,
  errors,
}: InputsProps): ReactElement => {
  const { t } = useTranslateText();
  const passwordField = useRef<TextInputRef | null>(null);
  const telephoneField = useRef<TextInputRef | null>(null);

  return (
    <View style={styles.textInputContainer}>
      <MobileNumberInput
        value={values.telephone}
        onChangeText={handleChange("telephone")}
        onChange={() => setFieldTouched("telephone")}
        onBlur={() => setFieldTouched("telephone")}
        inputLabel={t("registerScreen.telephone")}
        inputRef={telephoneField}
        returnKeyType="next"
        onSubmitEditing={() => passwordField.current?.focus()}
        showError={touched.telephone}
        error={errors.telephone}
      />
      <PasswordText
        inputRef={passwordField}
        value={values.password}
        onChangeText={handleChange("password")}
        onBlur={() => setFieldTouched("password")}
        inputLabel={t("loginScreen.password")}
        returnKeyType="done"
        onSubmitEditing={submitForm}
        showError={touched.password}
        error={errors.password}
        lastField
      />
    </View>
  );
};

export default Inputs;
